<template>
  <section :class="wrapperClass">

      <h5 class="d-none d-md-block mb-3">{{$t('vue.checkout.checkoutLoginRegister.registered')}}</h5>

    <form :action="loginUrl" method="post">
      <div class="form-row">
        <div class="form-group col-12">
            <label for="loginEmail">{{$t('general.emailAddress')}}</label>
            <input id="loginEmail" class="form-control" name="email"
                   :placeholder="$t('general.emailAddress')"
                   type="text">
        </div>

        <div class="form-group col-12">
          <label for="loginPassword">{{$t('vue.checkout.pages.fromRegister.password')}}</label>
          <div class="input-group ">
              <input id="loginPassword" :type="passwordFieldType" class="form-control form-control border-right-0"
                     name="password"
                     :placeholder="$t('vue.checkout.pages.fromRegister.password')">
            <div class="input-group-append"
                 v-on:click="togglePasswordVisibility">
                                                    <span class="input-group-text bg-white border-left-0"><i
                                                        :class="passwordFieldType === 'text' ? 'fa-eye-slash' : 'fa-eye'"
                                                        class="far"></i></span>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group form-check">
            <input id="remember" class="form-check-input" name="remember"
                   type="checkbox">
            <label class="form-check-label" for="remember">{{$t('auth.loginConsumer.loggedIn')}}</label>
          </div>
        </div>

      </div>

      <input :value="identifier" name="identifier" type="hidden">
      <input :value="csrfToken" name="_token" type="hidden">

      <button class="btn btn-outline-primary" dusk="submit" type="submit">{{$t('auth.loginConsumer.logIn')}}</button>
      <a :href="passwordResetUrl" target="_blank" class="btn btn-link">{{$t('auth.loginConsumer.forgotPassword')}}
      </a>
    </form>

    <p v-if="hasLoginError" class="text-primary">
      {{ loginErrorMessage }}
    </p>
  </section>
</template>

<script>
export default {
  name: "LoginForm",
  props: {
    loginError: {
      type: String,
      required: false,
      default: ""
    },
    hasLoginError: {
      type: Boolean,
      required: false,
      default: false
    },
    loginUrl: {
      type: String,
      required: true
    },
    passwordResetUrl: {
      type: String,
      required: true
    },
    csrfToken: {
      type: String,
      required: true
    },
    wrapperClass: {
      type: String,
      required: false,
      default: ""
    },
    identifier: {
      type: String,
      required: true
    },
  },
  methods: {
    togglePasswordVisibility () {
      this.passwordFieldType = (this.passwordFieldType === 'password') ? 'text' : 'password';
    },
  },


  computed: {
    loginErrorMessage () {
      return this.loginError
    }
  },
  mounted () {
    this.toggleRegister ();
  },

  data () {
    return {
      passwordFieldType: 'password'
    }
  },
}
</script>

<style scoped>

</style>
